import { render } from "./list-item.vue?vue&type=template&id=2b5ac31d&scoped=true&ts=true"
import script from "./list-item.vue?vue&type=script&lang=ts"
export * from "./list-item.vue?vue&type=script&lang=ts"

import "./list-item.vue?vue&type=style&index=0&id=2b5ac31d&lang=scss&scoped=true"

import exportComponent from "D:\\project\\fantan\\h5\\fantan\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b5ac31d"]])

export default __exports__